export default __webpack_public_path__ + "3c84cd3ee1b4c58071487abcd6c484af.svg";